import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import * as AuctionActions from 'libs/gb-front/auction/data-access/src/lib/+state/auction.actions'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src'
import * as AuthActions from 'libs/gb-front/auth/data-access/src/lib/+state/auth.actions'
import { AuthConstants } from 'libs/gb-front/auth/feature/login/src/lib/gb-front-auth-feature-login-routing.module'
import { take } from 'rxjs'
import {
  GbVerifyNotificationStatusService,
  VerifyNotificationStatusEnum,
} from '../gb-verify-notification-status-service/gb-verify-notification-status.service'

@Component({
  selector: 'gb-verify-notification',
  templateUrl: './gb-verify-notification.component.html',
  styleUrls: ['./gb-verify-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbVerifyNotificationComponent implements OnInit, OnDestroy {
  isAuthenticated$ = this.authFacade.isAuthenticated$

  nVStatus$ = this.gbVerifyNotificationStatusService.nVStatus$
  verifyNotificationStatus = VerifyNotificationStatusEnum

  constructor(
    private authFacade: AuthFacade,
    private route: ActivatedRoute,
    private gbVerifyNotificationStatusService: GbVerifyNotificationStatusService,
  ) {}

  get login(): string[] {
    const urlName = this.route.snapshot.params['urlName']
    return ['/', urlName, AuthConstants.LOGIN]
  }

  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      const token: string | null = params.get('token')
      if (token) {
        this.verifyNotification(token)
      }
    })
  }

  verifyNotification(token: string) {
    this.authFacade.dispatch(AuthActions.verifyNotification({ token }))
  }

  goToHomePage() {
    this.authFacade.dispatch(AuctionActions.redirectHomePage())
  }

  ngOnDestroy(): void {
    this.gbVerifyNotificationStatusService.nVClear()
  }
}
